module.exports = __webpack_public_path__ + "static/fonts/iconfont.79eebe48.woff2";